import clsx from "clsx";

interface TabProps extends React.ComponentProps<"input"> {
  selected: boolean;
  text: string;
}

export function Tab({ selected, text, ...props }: TabProps) {
  return (
    <label
      className={clsx(
        "px-4 py-1.5 font-medium cursor-pointer inset-ring rounded-full",
        "has-focus-visible:outline-2 has-focus-visible:outline-offset-2",
        "has-focus-visible:outline-blue-400 dark:has-focus-visible:outline-blue-600",
        "transition-all",
        {
          "text-neutral-600 dark:text-neutral-400": !selected,
          "inset-ring-neutral-200 dark:inset-ring-neutral-700": !selected,
          "hover:bg-neutral-100 hover:dark:bg-neutral-800": !selected,
          "text-blue-500 dark:text-blue-500 dark:bg-blue-800/10": selected,
          "inset-ring-2": selected,
        },
      )}
    >
      <input type="radio" className="sr-only" checked={selected} {...props} />
      {text}
    </label>
  );
}

export function NavTab({
  onClick,
  current,
  children,
}: {
  onClick: () => void;
  current: boolean;
  children?: React.ReactNode;
}) {
  return (
    <button
      className={clsx(
        "px-4 py-2 rounded-full font-medium cursor-pointer flex items-center gap-x-1",
        "inset-ring focus-visible:outline-2 outline-offset-2 outline-blue-500 transition-all",
        {
          "text-blue-500 inset-ring-2 inset-ring-blue-500 #bg-blue-100/50": current,
          "dark:text-blue-500 dark:inset-ring-blue-500 #dark:bg-blue-800/10": current,
          "text-neutral-700 inset-ring-neutral-200 hover:bg-neutral-100": !current,
          "dark:text-neutral-300 dark:inset-ring-neutral-700 dark:hover:bg-neutral-800": !current,
        },
      )}
      onClick={onClick}
    >
      {children}
    </button>
  );
}

export function NavTabContainer({ children }: { children: React.ReactNode }) {
  return (
    <div className="flex gap-x-2 border-b pb-4 border-neutral-100 dark:border-neutral-800">
      {children}
    </div>
  );
}
